<script setup>
	import NewIcon from "./NewIcon.vue";
	import { VBtn } from "vuetify/components";

	const props = defineProps({
		class: Array,
		disabled: Boolean
	});
	const emit = defineEmits([ "click" ]);

	function raiseClickEmit() {
		emit("click");
	}
</script>

<template>
	<VBtn title="Save and New"
		:class="props.class.concat(['mx-2', 'save-and-new-action'])"
		:disabled="props.disabled"
		@click="raiseClickEmit">
		<NewIcon/>
	</VBtn>
</template>
